import React from 'react'
import { useMount, UseRequestProvider } from 'ahooks'
import { requestConfig } from '@/utils/request'

import './App.less'
import '@/assets/styles/index.scss'
import Root from '@/routers/root'
// antd语言包
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { createUseStyles } from 'react-jss'
import { hot } from 'react-hot-loader/root'
import { tranfromLoadErrorImg } from './utils'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
moment.locale('zh-cn')

const styles = createUseStyles({
    '@font-face': {
        fontFamily: 'Bebas',
        src: 'url(' + require('@/assets/font/Bebas.TTF') + ')',
    },
})

const App = () => {
    styles()

    useMount(() => {
        tranfromLoadErrorImg()
    })

    return (
        // @ts-ignore
        <UseRequestProvider value={requestConfig}>
            <ConfigProvider locale={zhCN}>
                <DndProvider backend={HTML5Backend}>
                    <Root />
                </DndProvider>
            </ConfigProvider>
        </UseRequestProvider>
    )
}

// 开发环境时导出热更新组件
export default process.env.NODE_ENV === 'development' ? hot(App) : App
